import { render, staticRenderFns } from "./CompanionWidgetButton.vue?vue&type=template&id=67d46cb2"
import script from "./CompanionWidgetButton.vue?vue&type=script&lang=js"
export * from "./CompanionWidgetButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports